import axios from 'axios';
import { apiPath as ACTIVITIES_API_BASE } from '../../../config/apiBaseUrl';

export async function getEvents() {
  const url = `${ACTIVITIES_API_BASE}activities/events`;
  const { data } = await axios.get(url);
  return data;
}

export async function getEventDetail(name) {
  const url = `${ACTIVITIES_API_BASE}activities/events/${name}`;
  const { data } = await axios.get(url);
  return data;
}

export async function getPodcasts() {
  const url = `${ACTIVITIES_API_BASE}activities/podcasts`;
  const { data } = await axios.get(url);
  return data;
}

export async function getBlogs() {
  const url = `${ACTIVITIES_API_BASE}activities/blogs`;
  const { data } = await axios.get(url);
  return data;
}

export async function getBlogDetail(name) {
  const url = `${ACTIVITIES_API_BASE}activities/blogs/${name}`;
  const { data } = await axios.get(url);
  return data;
}

export async function getPodcastDetail(name) {
  const url = `${ACTIVITIES_API_BASE}activities/podcasts/${encodeURIComponent(name)}`;
  const { data } = await axios.get(url);
  return data;
}

export async function getCharleeAccolades(page = 1, limit = 10, searchWord = '') {
  const url = `${ACTIVITIES_API_BASE}charlee-accolades`;
  const { data } = await axios.get(url, {
    params: {
      page,
      limit,
      ...(searchWord ? { searchWord } : {}),
    },
  });
  const accolades = data?.data?.accolades ?? [];
  return {
    accolades,
    pagination: data?.data?.pagination ?? {
      total: accolades.length,
      page,
      limit,
      pages: 1,
    },
  };
}

export async function getUsecaseDetailByRelevance(relevance) {
  const url = `${ACTIVITIES_API_BASE}charlee-accolades/relevance/${encodeURIComponent(relevance)}`;
  const { data } = await axios.get(url);
  const record = data?.data ?? data;
  return record;
}

export async function getUsecaseDetail(relevance) {
  const activitiesUrl = `${ACTIVITIES_API_BASE}activities/usecases/${encodeURIComponent(relevance)}`;
  try {
    const { data } = await axios.get(activitiesUrl);
    return data;
  } catch (activitiesError) {
    try {
      return await getUsecaseDetailByRelevance(relevance);
    } catch (accoladesError) {
      console.log('Error fetching use case detail: ', activitiesError, accoladesError);
      throw accoladesError;
    }
  }
}
